import { request } from '@/apis/lib'

export function createGrayscale() {
  return request.get<any>('/v1/grayscale/owner', {
    ignoreError: true,
    noRedirect: true,
  })
}
